module.exports = __webpack_public_path__ + "34f16462015393320ca1de60876d75f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C000038M6.png
// module id = 1485
// module chunks = 0